import { Validator } from '@comparaonline/ui-forms-validators/dist/types/Validator';

export const blockedPlateCode = 'BLOCKED_PLATE';

export const blockedPlate: Validator<string> = (_, __, meta) =>
  meta?.data?.isBanned ? { errorCode: blockedPlateCode } : undefined;
